// extracted by mini-css-extract-plugin
export default {"dashboard":"Dashboard_dashboard__oPE0c","UnClickDashboard":"Dashboard_UnClickDashboard__Oo4el","pdfModal":"Dashboard_pdfModal__Fv2hZ"};